/**
 * metadata tags constants
 */
export const MetadataTagsConstants = {
  TEST_TYPE_LABEL: "TEST_TYPE",
  COMPETENCY_TEST_LABEL: "COMPETENCY_TEST",
  PROGRESS_TEST_LABEL: "PROGRESS_TEST",
  EXAM_PAPER_LABEL: "EXAM_PAPER",
  LISTENING_LABEL: 'LISTENING'
}
export const scoreFormatTypes = {
    percent: "percentage"
}
export const TestSubTypeConstants = {
  "competency": "COMPETENCY_TEST",
  "unit-progress": "PROGRESS_TEST",
  "practice": "PRACTICE_TEST",
  "course-specific":"COURSE_SPECIFIC_TEST"
}
/*
  This tag mapping is lagacy code that was written before adding MMA tag id in app (metadata-tags-defintion.json).
  As part of Test type builder flag migrations this mapping should be removed in phase 2.
*/
export const testTypeTagsEnum = {
  PRACTICE_TEST: "Practice test",
  COURSE_SPECIFIC_TEST: "Course specific test",
  COMPETENCY_TEST: "Competency test",
  PROGRESS_TEST: "Unit progress test"
}